import { useEffect, useState } from 'react';
import { VariantProps } from 'tailwind-variants';
import { nameBall } from './variants';

interface NamePill extends VariantProps<typeof nameBall> {
  name: string;
  className?: string;
  profile?: string;
}

export default function NamePill({
  name,
  profile,
  className,
  size = 'regular',
  color = 'primary',
}: NamePill) {
  const [pillContent, setPillContent] = useState<string>();

  useEffect(() => {
    const dividedName = name.split(' ')
      .filter(name=>name.length>0)
    const firstNameInitial = dividedName[0][0];
    let lastNameInitial = dividedName[dividedName.length - 1][0];

    if(!lastNameInitial) lastNameInitial = ""

    setPillContent(`${firstNameInitial}${lastNameInitial}`);
  }, [name]);

  if(profile) {
    return (
      <div
        style={{
          background: `url("${profile}")`,
          backgroundSize: 'contain'
        }}
        className={nameBall({ size, className })}
      />
    )
  }

  return (
    <div className={nameBall({ size, color, className })}>
      {pillContent}
    </div>
  );
}
